import { db } from '../db';
import type { ParticipantRecord } from '../types';

export async function getOrCreateParticipant(code: string): Promise<ParticipantRecord> {
  const trimmed = code.trim();
  if (!trimmed) throw new Error('참가자 코드가 비어 있습니다');
  const existing = await db.participants.where('code').equals(trimmed).first();
  if (existing) return existing;
  const rec: ParticipantRecord = { id: crypto.randomUUID(), code: trimmed, createdAt: new Date().toISOString() };
  await db.participants.add(rec);
  return rec;
}

export const listParticipants = () => db.participants.orderBy('createdAt').reverse().toArray();
